import React from 'react';

import FileDownload from '../../view/list/templates/ActionsTemplate/FileDownload';
import PrintFile from '../../view/list/templates/ActionsTemplate/PrintFile';

function FileVersionActionsTemplate({ rowData, e }) {
  return (
    <React.Fragment>
      <div key={e.rowIndex} className="d-flex gap-3">
        <span className="p-column-title text-break">Actions</span>

        {rowData.entry_type !== 'folder' && (
          <>
            <PrintFile rowData={rowData} />
            <FileDownload rowData={rowData} />
          </>
        )}
      </div>
    </React.Fragment>
  );
}

export default FileVersionActionsTemplate;
